export default __webpack_public_path__ + "static/media/BER.c8f7294d.jpeg";